var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ap-thread-participant-multiple-choice-preview-alert-msg",style:({
    backgroundColor: _vm.backgroundColor
  })},[_c('span',{staticClass:"alert-message",style:({
      color: _vm.backgroundColor === '#fff' ? '#000' : ''
    })},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }